module.exports = __webpack_public_path__ + "img/deselect.fe91c325.svg";